// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import React, { useState, ChangeEvent, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { KeywordTitle } from '../../../../redux/actionCreators/search/searchOnlineCoursesKeywordActions';
import { CardTypes } from '../../../../types/Model';
import { S } from './styles';

interface SearchBoxProps {
  placeholder?: string;
  keywords?: KeywordTitle[];
  commonKeywords: KeywordTitle[];
  type: CardTypes;
  handleSearch: (keyword: string) => void;
  handleStream?: (keyword: string) => void;
}

function SearchBox(props: SearchBoxProps): JSX.Element {
  const {
    placeholder = '輸入有興趣的關鍵字',
    keywords,
    commonKeywords,
    handleSearch,
    handleStream,
    type,
  } = props;
  const [inputText, setInputText] = useState<string>('');
  const [isRecommendationShow, setIsRecommendationShow] = useState<boolean>(false);
  const searchBoxRef = useRef<HTMLDivElement>(null);

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setInputText(e.target.value);
    if (typeof handleStream === 'function') {
      handleStream(e.target.value);
    }
    setIsRecommendationShow(true);
  }

  const handleEnterSearch = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.keyCode === 13) {
      e.preventDefault();
      handleSearch(inputText)
      setIsRecommendationShow(false);
    }
  }

  const handleRecommendationSearch = (keyword: string) => {
    setInputText(keyword);
    handleSearch(keyword);
    setIsRecommendationShow(false);
  }

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (!searchBoxRef.current) return;

      const isClickInside = Array.from(e.composedPath() as HTMLElement[]).includes(searchBoxRef.current);
      if (!isClickInside) {
        setIsRecommendationShow(false);
      }
    };
    window.addEventListener('click', handleClick)

    return () => {
      window.removeEventListener('click', handleClick);
    }
  }, [setIsRecommendationShow, searchBoxRef.current])

  return (
    <S.Container ref={searchBoxRef}>
      <S.Input
        placeholder={placeholder}
        value={inputText}
        onChange={handleInputChange}
        onKeyUp={handleEnterSearch}
      />
      <S.Icon onClick={() => handleSearch(inputText)} />
      <S.RecommendationContainer>
        {
          isRecommendationShow && keywords && [...keywords, ...commonKeywords].map((keyword) =>
            keyword.id === -1 ?
              (<S.RecommendationRow
                onClick={() => handleRecommendationSearch(keyword.name)}
                key={keyword.id}
              >
                {keyword.name}
              </S.RecommendationRow>)
              :
              (<S.RecommendationRow
                as={Link}
                target="blank"
                to={`/${type}s/${keyword.id}`}
                key={keyword.id}
              >
                <S.RecommendationTitle>
                  <S.RecommendationIcon type={type} />{keyword.name}
                </S.RecommendationTitle>
                <S.RecommendationLinkIcon />
              </S.RecommendationRow>)

          )
        }
      </S.RecommendationContainer>
    </S.Container>
  )
}

export { SearchBox as default };
